import React from 'react';

/**
 * Universal Form Header
 * Designed to replace the default Modal image header for forms.
 * Provides a clean title, optional subtitle, and a standard close button.
 */
export const FormHeader = ({ title, subtitle, subtitleClassName, onClose }) => {
  return (
    <div className="flex justify-between items-start mb-4">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {subtitle && (
          <p className={`text-xs mt-1 ${subtitleClassName || 'text-gray-500'}`}>
            {subtitle}
          </p>
        )}
      </div>
      {onClose && (
        <button 
          type="button" 
          onClick={onClose} 
          className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition-colors cursor-pointer flex-shrink-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      )}
    </div>
  );
};
